import { createFileRoute } from "@tanstack/react-router";
import { EsPlaceholder, esHead } from "@/knowmeno/marketing/EsPlaceholder";

export const Route = createFileRoute("/es/tienda")({
  head: () => esHead({
    path: "/tienda",
    title: "Tienda — Wearables y productos para menopausia | SepaMeno",
    description: "Wearables y productos curados para acompañar tu menopausia. Próximamente en español.",
    englishPath: "/store",
  }),
  component: () => (
    <EsPlaceholder
      title="Tienda"
      subtitle="Wearables y productos curados para acompañarte. Estamos preparando la tienda en español."
      englishHref="https://knowmeno.com/store"
    />
  ),
});
